"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3442],{

/***/ 41516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgForosLogo = function SvgForosLogo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 100 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.084 3.26v6.723h9.24c0 1.066-.888 2.727-1.763 2.79H3.084v8.791C3.008 22.53 1.18 23.531 0 23.505V.482h13.962c0 1.066-.876 2.727-1.751 2.778H3.084ZM52.524 7.192a3.64 3.64 0 0 0-1.155-3.133 6.273 6.273 0 0 0-3.732-.862h-4.036v8.22h3.807a8.889 8.889 0 0 0 3.034-.406 2.678 2.678 0 0 0 1.574-1.269c.37-.797.544-1.671.508-2.55Zm.355 15.35-5.267-8.424H43.6v7.446c-.077.965-1.917 1.967-3.085 1.941V.482h7.16c2.868 0 4.911.533 6.155 1.586a6.014 6.014 0 0 1 1.866 4.896 7.71 7.71 0 0 1-1.117 4.452 5.738 5.738 0 0 1-3.694 2.208l1.27 1.94 4.518 7.142v.089l.127.177c-.964.647-3.02.787-3.592 0l-.279-.456-.05.025ZM99.31 17.213a6.148 6.148 0 0 1-2.12 4.998A9.435 9.435 0 0 1 90.985 24a11 11 0 0 1-5.192-1.104 8.388 8.388 0 0 1-3.401-3.412c2.018-1.42 3.376-.393 3.54-.216l.306.292a6.526 6.526 0 0 0 4.683 1.7 6.349 6.349 0 0 0 3.808-1.015 3.248 3.248 0 0 0 1.41-2.803 3.043 3.043 0 0 0-.445-1.713 4.022 4.022 0 0 0-1.18-1.18 7.1 7.1 0 0 0-1.689-.76 29.05 29.05 0 0 0-1.98-.559 68.719 68.719 0 0 1-3.16-.85 10.42 10.42 0 0 1-2.54-1.141 5.163 5.163 0 0 1-1.687-1.789 5.641 5.641 0 0 1-.622-2.816 6.25 6.25 0 0 1 1.967-4.845A8.571 8.571 0 0 1 90.755 0a9.373 9.373 0 0 1 4.989 1.154 8.667 8.667 0 0 1 2.944 2.969c-2.284 1.661-3.3.494-3.63.215l-.114-.114a6.623 6.623 0 0 0-.889-.685 6.197 6.197 0 0 0-3.3-.812 5.512 5.512 0 0 0-3.503.99 3.235 3.235 0 0 0-1.27 2.65 2.79 2.79 0 0 0 .369 1.485c.269.436.65.79 1.104 1.027a7.492 7.492 0 0 0 1.739.71l2.374.559c1.04.28 2.043.57 2.982.875a9.36 9.36 0 0 1 2.539 1.205 5.329 5.329 0 0 1 1.663 1.928c.437.957.629 2.008.558 3.057Z",
    fill: "#014152"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.306 12.05c0 6.508-4.201 11.633-9.647 11.912h-.482c-.431 0-.8 0-.8-.393v-9.514l-3.02 2.778c-.445-.47-.724-1.586-.356-1.979l3.376-3.082V9.64L65.7 12.089c-.444-.457-.723-1.573-.355-1.966l3.198-2.855.153-.14a.762.762 0 0 1 .533-.19.762.762 0 0 1 .533.19l.152.14 3.11 2.88c.368.393.089 1.51-.355 1.966l-2.679-2.473v2.143l3.377 3.083c.368.393.089 1.51-.368 1.979l-3.009-2.778v7.09c3.643-.507 6.487-4.389 6.487-9.107 0-5.074-3.275-9.159-7.299-9.159-4.024 0-7.286 4.11-7.286 9.159-.028 2.219.648 4.39 1.93 6.203l.076.114a4.73 4.73 0 0 1-.508 3.526 12.57 12.57 0 0 1-4.328-9.843C59.06 5.366 63.503.127 69.215.127S79.306 5.366 79.306 12.05Z",
    fill: "#D9B310"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.786 12.05c0 5.075 3.274 9.16 7.298 9.16s7.299-4.11 7.299-9.16c0-5.048-3.275-9.158-7.299-9.158-4.023 0-7.298 4.11-7.298 9.159Zm17.414 0c0 6.698-4.442 11.937-10.154 11.937s-10.154-5.239-10.154-11.936c0-6.698 4.442-11.924 10.154-11.924S36.2 5.366 36.2 12.05Z",
    fill: "#014152"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgForosLogo);

/***/ }),

/***/ 28658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_0__);

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  rounded-lg\n  bg-white\n  flex\n  flex-col\n  relative\n  p-4\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Card = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_0___default().div(_templateObject());


/***/ }),

/***/ 29371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ErrorMessages; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__);


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  leading-6\n  text-red-500\n  text-sm\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Error = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().p(_templateObject());
var ErrorMessages = function(_param1) {
    var error = _param1.error, fallback = _param1.fallback, props = _objectWithoutProperties(_param1, [
        "error",
        "fallback"
    ]);
    return error ? error.types ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: Object.entries(error.types).map(function(param) {
            var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Error, _objectSpread({}, props, {
                children: [
                    "\xa0",
                    value
                ]
            }), key);
        })
    }) : error.message ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Error, _objectSpread({}, props, {
        children: [
            "\xa0",
            error.message
        ]
    })) : null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: fallback
    });
};



/***/ }),

/***/ 48375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63955);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Form(_param) {
    var children = _param.children, onSubmit = _param.onSubmit, className = _param.className, methods = _objectWithoutProperties(_param, [
        "children",
        "onSubmit",
        "className"
    ]);
    var handleSubmit = methods.handleSubmit;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .FormProvider */ .RV, _objectSpread({}, methods, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
            onSubmit: handleSubmit(onSubmit),
            className: className,
            children: children
        })
    })));
}


/***/ }),

/***/ 10809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63955);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33052);
/* harmony import */ var _ErrorMessages__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29371);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "flex flex-col flex-1 items-start"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "mr-2"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  items-center\n  ",
        "\n  px-3\n  md:px-4\n  py-2\n  h-10\n  md:h-11\n  border\n  rounded-lg\n  ",
        "\n  focus-within:border-secondary-500\n  w-full\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  self-stretch\n  items-center\n  justify-between\n  mb-1\n  md:mb-2\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  text-sm\n  font-semibold\n  text-gray-800\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  text-sm\n  md:text-base\n  text-gray-800\n  bg-transparent\n  placeholder-gray-600\n  w-full\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  text-primary-500\n  hover:underline\n  cursor-pointer\n  text-sm\n  md:text-md\n  ml-2\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  text-sm\n  text-gray-600\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
var Container = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().div(_templateObject());
var PrefixContainer = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().div(_templateObject1());
var InputContainer = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().div(_templateObject2(), function(param) {
    var disabled = param.disabled;
    return disabled ? 'bg-gray-200' : 'bg-white';
}, function(param) {
    var $error = param.$error;
    return $error ? 'border-red-500' : 'border-gray-400';
});
var LabelContainer = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().div(_templateObject3());
var Label = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().label(_templateObject4());
var Input = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().input(_templateObject5());
var PsSuffix = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().p(_templateObject6());
var Hint = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().p(_templateObject7());
var TextInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var label = _param.label, name = _param.name, className = _param.className, _type = _param.type, type = _type === void 0 ? 'text' : _type, disabled = _param.disabled, prefix = _param.prefix, error = _param.error, hint = _param.hint, labelHint = _param.labelHint, props = _objectWithoutProperties(_param, [
        "label",
        "name",
        "className",
        "type",
        "disabled",
        "prefix",
        "error",
        "hint",
        "labelHint"
    ]);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), inputVisible = ref1[0], setVisible = ref1[1];
    var context = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useFormContext */ .Gc)();
    var fieldError = error || (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2)(context === null || context === void 0 ? void 0 : context.formState.errors, name);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        className: className,
        children: [
            (label || labelHint) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(LabelContainer, {
                children: [
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
                        children: label
                    }),
                    labelHint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PsSuffix, _objectSpread({}, labelHint, {
                        className: "font-semibold",
                        children: labelHint.title
                    }))
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputContainer, {
                disabled: disabled,
                $error: fieldError,
                children: [
                    prefix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrefixContainer, {
                        children: prefix
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, _objectSpread({
                        name: name,
                        type: inputVisible ? 'text' : type,
                        disabled: disabled,
                        ref: ref
                    }, props)),
                    type === 'password' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PsSuffix, {
                        onClick: function() {
                            return setVisible(!inputVisible);
                        },
                        children: inputVisible ? t('input.hide') : t('input.show')
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrorMessages__WEBPACK_IMPORTED_MODULE_5__/* .ErrorMessages */ .X, {
                error: fieldError,
                fallback: hint ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Hint, {
                    children: hint
                }) : null
            })
        ]
    }));
});



/***/ }),

/***/ 72499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ NavLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46487);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_3__);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "text-sm hover:underline cursor-pointer ",
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var colorsClassNameRegexp = new RegExp(Object.keys((_config__WEBPACK_IMPORTED_MODULE_3___default().colors)).map(function(color) {
    return "text-".concat(color);
}).join('|'));
var Anchor = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().a(_templateObject(), function(param) {
    var className = param.className;
    return (className === null || className === void 0 ? void 0 : className.match(colorsClassNameRegexp)) ? '' : 'text-primary-500';
});
var NavLink = function(_param) /*#__PURE__*/ {
    var href = _param.href, linkProps = _param.linkProps, props = _objectWithoutProperties(_param, [
        "href",
        "linkProps"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], _objectSpread({}, linkProps, {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anchor, _objectSpread({}, props))
    }));
};



/***/ }),

/***/ 96172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aU": function() { return /* binding */ useLogout; },
/* harmony export */   "f0": function() { return /* binding */ useLogin; },
/* harmony export */   "b3": function() { return /* binding */ useUnauthorizedRedirect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34028);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58451);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2811);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_4__);




function useLogout() {
    var client = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useApolloClient */ .x)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        router.push('/');
        sessionStorage.removeItem(_config__WEBPACK_IMPORTED_MODULE_3__/* .authTokenKey */ .Dn);
        localStorage.removeItem(_config__WEBPACK_IMPORTED_MODULE_3__/* .authTokenKey */ .Dn);
        client.resetStore();
    }, [
        client,
        router
    ]);
}
function useLogin() {
    var client = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useApolloClient */ .x)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(token) {
        var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _redirectPath = ref.redirectPath, redirectPath = _redirectPath === void 0 ? (_config__WEBPACK_IMPORTED_MODULE_4___default().current.authenticatedLandingPath) : _redirectPath, _expires = ref.expires, expires = _expires === void 0 ? true : _expires;
        if (!token) return;
        sessionStorage.removeItem(_config__WEBPACK_IMPORTED_MODULE_3__/* .leadUserKey */ .vR);
        sessionStorage.removeItem(_config__WEBPACK_IMPORTED_MODULE_3__/* .emailKey */ .Ug);
        var storage = expires ? sessionStorage : localStorage;
        storage.setItem(_config__WEBPACK_IMPORTED_MODULE_3__/* .authTokenKey */ .Dn, token);
        client.resetStore();
        if (redirectPath) {
            router.replace(redirectPath);
        }
    }, [
        client,
        router
    ]);
}
function useUnauthorizedRedirect(data, loading) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!loading && !(data === null || data === void 0 ? void 0 : data.currentUser)) {
            router.replace('/');
        }
    }, [
        loading,
        data,
        router
    ]);
}


/***/ }),

/***/ 75920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V4": function() { return /* binding */ clientOnlyComponent; },
/* harmony export */   "EG": function() { return /* binding */ clientOnlyModule; },
/* harmony export */   "lb": function() { return /* binding */ formatMoney; },
/* harmony export */   "J3": function() { return /* binding */ formatValueMoney; },
/* harmony export */   "rV": function() { return /* binding */ formatArea; },
/* harmony export */   "fP": function() { return /* binding */ formatVolume; },
/* harmony export */   "Hm": function() { return /* binding */ getErrorTranslations; },
/* harmony export */   "Se": function() { return /* binding */ arrayToChunks; },
/* harmony export */   "j2": function() { return /* binding */ humanDurationString; },
/* harmony export */   "mE": function() { return /* binding */ endTimestamp; },
/* harmony export */   "$1": function() { return /* binding */ enumToOption; },
/* harmony export */   "U5": function() { return /* binding */ setFormFieldsErrorTranslations; },
/* harmony export */   "iX": function() { return /* binding */ setFormFieldErrorTranslation; },
/* harmony export */   "md": function() { return /* binding */ removeDuplicateObjects; }
/* harmony export */ });
/* unused harmony export reduceNestedUniqueLists */
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25237);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33052);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96299);
/* harmony import */ var humanize_duration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75951);
/* harmony import */ var humanize_duration__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humanize_duration__WEBPACK_IMPORTED_MODULE_2__);




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var _resultArray;
function clientOnlyComponent(component) {
    return (0,next_dynamic__WEBPACK_IMPORTED_MODULE_0__["default"])(Promise.resolve(component), {
        ssr: false
    });
}
function clientOnlyModule(loader) {
    return (0,next_dynamic__WEBPACK_IMPORTED_MODULE_0__["default"])(loader, {
        ssr: false
    });
}
function formatMoney(money) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!money) return;
    var amount = money.amount, currency = money.currency;
    var formatter = Intl.NumberFormat(next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === null || next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === void 0 ? void 0 : next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n.language */ .ag.language, _objectSpread({
        style: 'currency',
        currency: currency.isoCode
    }, options));
    return formatter.format(parseFloat(amount));
}
function formatValueMoney(money) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!money) {
        var t = next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === null || next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === void 0 ? void 0 : next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n.getFixedT */ .ag.getFixedT(next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n.language */ .ag.language, 'common');
        return t === null || t === void 0 ? void 0 : t('calculating');
    }
    return formatMoney(money, options);
}
function formatArea(area) {
    if (typeof area !== 'number') return;
    var t = next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === null || next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === void 0 ? void 0 : next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n.getFixedT */ .ag.getFixedT(next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n.language */ .ag.language, 'common');
    return "".concat(area.toFixed(2), " ").concat(t === null || t === void 0 ? void 0 : t('hectare'));
}
function formatVolume(volume, units) {
    if (typeof volume !== 'number') return;
    var t = next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === null || next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === void 0 ? void 0 : next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n.getFixedT */ .ag.getFixedT(next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n.language */ .ag.language, 'common');
    return "".concat(volume.toFixed(2), " ").concat(units !== null && units !== void 0 ? units : t === null || t === void 0 ? void 0 : t('cubicMeters'));
}
function getErrorTranslations(enumName, errors) {
    var t = next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === null || next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === void 0 ? void 0 : next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n.getFixedT */ .ag.getFixedT(next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n.language */ .ag.language, 'enum');
    return {
        types: errors.reduce(function(accumulator, error) {
            accumulator[error] = t === null || t === void 0 ? void 0 : t("".concat(enumName, ".").concat(error));
            return accumulator;
        }, {})
    };
}
function arrayToChunks(array, perChunk) {
    return array.reduce(function(resultArray, item, index) {
        var chunkIndex = Math.floor(index / perChunk);
        var _chunkIndex;
        (_chunkIndex = (_resultArray = resultArray)[chunkIndex]) !== null && _chunkIndex !== void 0 ? _chunkIndex : _resultArray[chunkIndex] = [];
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
function humanDurationString(endTime, startTime) {
    var now = startTime ? luxon__WEBPACK_IMPORTED_MODULE_3__/* .DateTime.fromISO */ .ou.fromISO(startTime) : luxon__WEBPACK_IMPORTED_MODULE_3__/* .DateTime.local */ .ou.local();
    var endDateTime = luxon__WEBPACK_IMPORTED_MODULE_3__/* .DateTime.fromISO */ .ou.fromISO(endTime);
    var duration = luxon__WEBPACK_IMPORTED_MODULE_3__/* .Interval.fromDateTimes */ .Xp.fromDateTimes(now.startOf('second'), endDateTime.startOf('second')).toDuration().toMillis();
    return humanize_duration__WEBPACK_IMPORTED_MODULE_2___default()(duration, {
        language: next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === null || next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === void 0 ? void 0 : next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n.language */ .ag.language,
        fallbacks: [
            'en'
        ],
        largest: 3
    });
}
function endTimestamp(endTime) {
    return luxon__WEBPACK_IMPORTED_MODULE_3__/* .DateTime.fromISO */ .ou.fromISO(endTime).toFormat('yyyy-MM-dd HH:mm (ZZZZ)');
}
function enumToOption(enumObject) {
    return Object.values(enumObject).map(function(value) {
        return {
            label: value,
            value: value
        };
    });
}
function setFormFieldsErrorTranslations(setError, error, fieldEnumMap) {
    var entries = Object.entries(fieldEnumMap);
    entries.forEach(function(param) {
        var _param = _slicedToArray(param, 2), field = _param[0], enumName = _param[1];
        return setFormFieldErrorTranslation(setError, field, error[field], enumName);
    });
}
function setFormFieldErrorTranslation(setError, field, errors, enumName) {
    if (Array.isArray(errors)) {
        setError(field, getErrorTranslations(enumName, errors));
    }
}
function removeDuplicateObjects(array) {
    return array.filter(function(item, i) {
        return array.findIndex(function(param) {
            var id = param.id;
            return item.id === id;
        }) === i;
    });
}
function reduceNestedUniqueLists(items, listNames) {
    var lists = items.reduce(function(accumulator, item) {
        var _index;
        listNames.forEach(function(name, index) {
            return (_index = accumulator[index]).push.apply(_index, _toConsumableArray(item[name]));
        });
        return accumulator;
    }, listNames.map(function(name) {
        return new Array();
    }));
    return Object.fromEntries(lists.map(function(list, index) {
        return [
            listNames[index],
            removeDuplicateObjects(list)
        ];
    }));
}


/***/ })

}]);